import { ITagList } from 'source/NFR.types';

const TagList: React.FC<ITagList> = ({ tags = [] }) => {
  if (!tags.length) return null;

  return (
    <ul className="tag-list">
      {tags?.map((tag, index) => (
        <li key={tag.text + String(index)} className="tag-list__tag">
          {tag.text}
        </li>
      ))}
    </ul>
  );
};

TagList.displayName = 'TagList';

export default TagList;
